import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { DateTime, Info } from 'luxon';
import { CardModule } from 'primeng/card';
import { BadgeModule } from 'primeng/badge';
import { TranslationPipe } from '../../../pipes/translation.pipe';
import { ButtonModule } from 'primeng/button';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-calendar-widget',
  imports: [CommonModule, RouterModule, CardModule, BadgeModule, TranslationPipe, ButtonModule,],
  providers: [TranslationPipe],
  templateUrl: './calendar-widget.component.html',
  styleUrl: './calendar-widget.component.scss'
})
export class CalendarWidgetComponent {

  // watch out for off-by-one errors!
  getCurrentMonthLong() {
    return DateTime.now().monthLong
  }

  getCurrentMonth() {
    return DateTime.now().month
  }

  getDaysOfCurrentMonth() {
    return DateTime.now().daysInMonth
  }

  getFirstDayOfCurrentMonth() {
    return DateTime.now().set({ day: 1 })
  }

  getFirstDayOfFirstCalendarWeek() {
    let firstDayOfMonth = this.getFirstDayOfCurrentMonth()
    let weekday = firstDayOfMonth.localWeekday.valueOf()
    return firstDayOfMonth.minus({ days: (weekday - 1) })
  }

  getWeekDaysShort() {
    return Info.weekdays("short")
  }

  getDayOfMonth(week: number, day: number) {
    let firstDayOfMonth = this.getFirstDayOfFirstCalendarWeek();
    let result = firstDayOfMonth.plus({ days: day - 1, weeks: week - 1 });
    return result
  }

  isDayInMonth(week: number, day: number) {
    return this.getDayOfMonth(week, day).month == this.getCurrentMonth()
  }

  getToday() {
    return DateTime.now().day
  }

  getSeverityForDay(week: number, day: number): "info" | "success" | "warn" | "danger" | "secondary" | "contrast" {
    var today = DateTime.now();
    var dateToCheck = this.getDayOfMonth(week, day);
    if (dateToCheck.day == today.day && dateToCheck.month == today.month) {
      return "info"
    }
    return 'contrast'
  }

}
